/**
 * Assert that API response data is defined. Use this helper to replace non-null assertions (data!) with runtime
 * validation.
 *
 * TypeScript will produce an error if you pass a value that's guaranteed to be undefined. This prevents calling
 * ensureApiData on responses that never have data (like 204 No Content).
 *
 * @example
 *   const { data } = await client.GET("/users");
 *   return ensureApiData(data, "GET /users");
 */
export function ensureApiData<T>(data: undefined extends T ? never : T | undefined, endpoint: string): T {
  if (data === undefined) {
    throw new Error(`Unexpected empty response from ${endpoint}`);
  }
  return data;
}
